import React from 'react';
import { useTranslation } from 'react-i18next';
import { LOGO_SRC } from 'lib/site';
import { cn } from 'lib/utils';

interface LogoMarkProps {
  /** Badge edge length in px. Default 28. */
  size?: number;
  className?: string;
}

/** Prefer this over an ad-hoc lucide glyph so every compact brand chip renders the real logo. */
export const LogoMark: React.FC<LogoMarkProps> = ({ size = 28, className }) => {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center',
        className,
      )}
      style={{ width: size, height: size }}
    >
      <img src={LOGO_SRC} alt={t('examing')} className="block h-full w-full" />
    </span>
  );
};

export default LogoMark;
